import { configureStore } from "@reduxjs/toolkit";
import userDetailReducer from "./userDetailSlice";

export const store = configureStore({
  reducer: {
    userDetail: userDetailReducer,
  },
});

export default store;
